/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { normalizeVariantUpdateData } from './helpers/normalizeVariantUpdateData';
import { formatProductUpdateErrorMessage } from './helpers/formatProductUpdateErrorMessage';

export const updateMasterVariant = createAsyncThunk(
  'products/updateMasterVariant',
  async ({ productId, variantId, data }, {
    extra: {
      sdk, Logger, showErrorDialog, utils,
    },
  }) => {
    try {
      const normalizedData = normalizeVariantUpdateData(data);
      const { data: updatedVariant } = await sdk.products.updateVariant(productId, variantId, normalizedData);
      return updatedVariant;
    } catch (error) {
      const rawMessage = utils.getDataFromResponceError(error, 'msg');
      const errorMessage = rawMessage
        ? formatProductUpdateErrorMessage(rawMessage)
        : 'Cannot update product variant';
      showErrorDialog(errorMessage);
      Logger.error(new Error('Error updating master product variant'), { error }, [
        'UpdateMasterVariantFailed',
        { errorMessage: rawMessage || errorMessage || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(updateMasterVariant.pending, (state, { meta }) => {
      const { productId } = meta.arg;
      state.items.forEach((product) => {
        if (product._id === productId) {
          product.isBusy = true;
        }
      });
    })
    .addCase(updateMasterVariant.fulfilled, (state, { meta, payload }) => {
      const { productId } = meta.arg;
      state.items.forEach((product) => {
        if (product._id === productId) {
          product.isBusy = false;
          product.variants = (product.variants || []).map((variant) => (
            variant._id === payload._id ? { ...variant, ...payload } : variant
          ));
        }
      });
    })
    .addCase(updateMasterVariant.rejected, (state, { meta, error }) => {
      state.items.forEach((product) => {
        if (product._id === meta.arg.productId) {
          product.isBusy = false;
        }
      });
      state.error = error;
    });
};
